import {
  Box,
  Button,
  Heading,
  Input,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotAdminPassword } from "../api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const toast = useToast();

  const handleSubmit = async () => {
    if (!email.trim()) {
      toast({
        title: "이메일을 입력해주세요.",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      await forgotAdminPassword(email.trim());
      setSent(true);
    } catch (e) {
      toast({
        title: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
        status: "error",
        duration: 2500,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-b, white, blue.50)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        w="480px"
        bg="white"
        p="40px"
        borderRadius="20px"
        boxShadow="lg"
      >
        <Heading fontFamily="Pretendard" fontSize="24px" mb="8px">
          비밀번호 찾기
        </Heading>

        {!sent ? (
          <VStack spacing="4" align="stretch" mt="32px">
            <Text fontSize="14px" color="gray.600">
              가입하신 이메일 주소를 입력하시면 비밀번호 재설정 링크를
              보내드립니다.
            </Text>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Input
                h="46px"
                mb="16px"
                placeholder="이메일 주소"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                type="submit"
                isLoading={loading}
                w="100%"
                h="46px"
                bg="#0054C0"
                color="white"
                fontFamily="Pretendard"
                fontSize="16px"
                _hover={{ bg: "#0043A0" }}
              >
                재설정 링크 보내기
              </Button>
            </form>
            <Link to="/login">
              <Text
                fontSize="13px"
                color="blue.500"
                textAlign="center"
                mt="4px"
                _hover={{ textDecoration: "underline" }}
              >
                로그인으로 돌아가기
              </Text>
            </Link>
          </VStack>
        ) : (
          <VStack spacing="4" align="center" mt="32px">
            <Text fontSize="15px" color="gray.700" textAlign="center">
              <b>{email}</b>으로 비밀번호 재설정 링크를 전송했습니다.
            </Text>
            <Text fontSize="14px" color="gray.500" textAlign="center">
              메일함을 확인해 주세요. (스팸함도 확인해 보세요)
            </Text>
            <Text fontSize="13px" color="gray.400" textAlign="center">
              링크는 15분간 유효합니다.
            </Text>
            <Link to="/login">
              <Text
                fontSize="13px"
                color="blue.500"
                _hover={{ textDecoration: "underline" }}
              >
                로그인으로 돌아가기
              </Text>
            </Link>
          </VStack>
        )}
      </Box>
    </Box>
  );
}
